import React, { useEffect } from 'react'
import useLanguage from '../customHook/useLanguage'
import i18n from '../../i18n';

function I18Initialisation( { children } ) {
    const languageState = useLanguage();

   useEffect(()=> {
    i18n.changeLanguage(languageState.slice(0,2))
   },[languageState]);

  return (
    <>{ children }</>
  )
}

export default I18Initialisation;   